module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'serial-list'
      }
    }
  }, [_vm._v("Serials")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.serial))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('date-range-picker', {
    on: {
      "daterange-change": _vm.dateRangeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('track-days', {
    attrs: {
      "date-start": _vm.epochStart,
      "date-end": _vm.epochEnd,
      "days": _vm.sortedTrackLogs
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.activeTab === 'details' ? 'active' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTab('details')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'licenses' ? 'active' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTab('licenses')
      }
    }
  }, [_vm._v("Licenses")])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'proxy' ? 'active' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTab('proxy')
      }
    }
  }, [_vm._v("Proxy Stats")])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'os' ? 'active' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTab('os')
      }
    }
  }, [_vm._v("OS Stats")])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'events' ? 'active' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTab('events')
      }
    }
  }, [_vm._v("Events")])])])]), _vm._v(" "), (_vm.activeTab === 'details') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Serial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serial))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Customer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.customer))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.locationCountry))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.locationCity))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Wedge SO Version")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.softwareVersion))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Service Tag")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.serviceTag))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MAC Address")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.mac))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Support Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.supportGroup))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('google-map', {
    attrs: {
      "coordinates": _vm.locationCoordinates,
      "height": "250px"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'licenses') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.serialLicenses.length === 0) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("No licenses have been activated for this appliance serial.")])]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Activated")]), _vm._v(" "), _c('th', [_vm._v("Issued")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _vm._l((_vm.licenseServices), function(service) {
    return _c('th', [_vm._v(_vm._s(service))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.reducedLicenses), function(license) {
    return _c('tr', {
      class: _vm.licenseRowClass(license.expired, license.expiresInDays)
    }, [_c('td', [_vm._v(_vm._s(license.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.activated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.issued))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.expiryDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.expiresFromNow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.duration))]), _vm._v(" "), _vm._l((_vm.licenseServices), function(service) {
      return _c('td', [(license.services[service]) ? _c('span', {
        staticClass: "glyphicon glyphicon-ok",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e()])
    })], 2)
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'proxy') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.requestsChartOptions,
      "series": _vm.requestsChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.connectionsChartOptions,
      "series": _vm.connectionsChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.malwareChartOptions,
      "series": _vm.malwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.bytesChartOptions,
      "series": _vm.bytesChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.aiMalwareChartOptions,
      "series": _vm.aiMalwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.aiGraywareChartOptions,
      "series": _vm.aiGraywareChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.sandboxMalwareChartOptions,
      "series": _vm.sandboxMalwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.sandboxCleanChartOptions,
      "series": _vm.sandboxCleanChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.urlsChartOptions,
      "series": _vm.urlsChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.spamChartOptions,
      "series": _vm.spamChartSeries
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'os') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.netIngressChartOptions,
      "series": _vm.netIngressChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.netEgressChartOptions,
      "series": _vm.netEgressChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.netBridgeChartOptions,
      "series": _vm.netBridgeChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.netControlChartOptions,
      "series": _vm.netControlChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.uespFsCfChartOptions,
      "series": _vm.uespFsCfChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  })])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'events') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [(_vm.serialEvents.length > 0) ? _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.serialEventsParsed,
      "columns": _vm.eventTableColumns,
      "options": _vm.eventTableOptions
    }
  }, [_c('v-client-table')], 1)], 1) : _c('div', [_vm._v("\n          No events.\n        ")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56cb12da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Serial.vue
// module id = 501
// module chunks = 2